/* eslint-disable */
import { ORDERS_ALL_ADDRESSES } from '../../../Store/Orders/Orders.types';

/**
 * The orders events
 * @param {func} metaDataFunc The meta data func
 * @returns {any} The analytics data
 */
const ordersEvent = (metaDataFunc) => ({
  [ORDERS_ALL_ADDRESSES]: () => {
    return {
      ...metaDataFunc(),
      event: ORDERS_ALL_ADDRESSES,
    };
  },
});

export default ordersEvent;
